// SPEC-096: the backend refuses a second concurrent subscribe or plan change
// with a 400 "…is already being processed. Please wait a moment." (backend
// PR #60). That is not a failure: the first request is still running and
// decides the outcome. The 400 arrives as a failure payload or, through
// fetchFailureMiddleware, as a thrown FormSubmissionError.
const PHRASE = 'already being processed'

export const isAlreadyProcessing = (payloadOrError) => {
  if (!payloadOrError) return false
  const candidates = [
    payloadOrError,
    payloadOrError.errors,
    payloadOrError.value
  ]
  return candidates.some((c) => {
    if (!c) return false
    try {
      return (typeof c === 'string' ? c : JSON.stringify(c)).includes(PHRASE)
    } catch (_) {
      return false
    }
  })
}

export default isAlreadyProcessing
